<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import { CDN } from '@/models/cdn.ts'
import PlayerName from '@/components/Objects/PlayerName.vue'
import { useGameStore } from '@/stores/gameStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore();

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="CDN.spyDead(64,props.newsItem.contentData.imageCode)"
    :toast-text="t('news.types.spyKilled.title')"
  >
    <NewsItemBaseStructure
      :newsItem="props.newsItem"
      :item-image="CDN.spyDead(512,props.newsItem.contentData.imageCode)"
      :header="t('news.types.spyKilled.title')"
    >
      <span class="text-metal-300">{{ props.newsItem.contentData.name }}</span> {{ t('news.types.spyKilled.body', { mission: t(`diplomacy.spies.missions.${props.newsItem.contentData.mission}.name`) }) }} (<PlayerName :player-id="props.newsItem.contentData.targetPlayerId" />)
      <span v-if="gameStore.combatMode === 'RC'" class="text-red-500 block mt-2">
        {{ t('news.types.spyKilled.warning') }}
      </span>
    </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>